var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.loadingClass},[(_vm.type)?_c('span',{staticClass:"weui-primary-loading__dot"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }